import axios from 'axios'
import { CREATED } from 'http-status-codes'
import { useState } from 'react'
import { Create, SaveButton, Toolbar, useNotify, useRedirect } from 'react-admin'

import { captureExceptionIfProduction } from 'helpers/utils'
import { FuelForm } from './FuelForm'

function saveFuelReceipt(receipt_payload: any) {
  const url = `/api/v1/console/fuel-receipts/`
  const formData = new FormData()
  for (const [key, value] of Object.entries<any>(receipt_payload)) {
    formData.append(key, value)
  }
  return axios
    .post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => {
      if (response.status === CREATED) {
        return response.data
      }
    })
}

const SaveButtonAltered = (props: any) => {
  const redirectTo = useRedirect()
  const notify = useNotify()
  const { basePath } = props
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = (values: any, redirect: any) => {
    setIsLoading(true)
    const receipt_payload = {
      date_purchased: values.date_purchased,
      fuel_attachment: values.fuel_attachment.rawFile,
      jurisdiction: values.jurisdiction,
      price_per_gallon: values.price_per_gallon,
      reported_by: values.user.id,
      total_gallons: values.total_gallons,
      truck: values.truck.id,
    }
    saveFuelReceipt(receipt_payload)
      .then(() => {
        notify('Receipt uploaded successfully.', { type: 'success' })
        redirectTo(redirect, basePath)
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false)
        if ('date_last_possible_edit' in error.response.data) {
          notify(error.response.data.date_last_possible_edit[0], { type: 'error' })
        } else if ('jurisdiction' in error.response.data) {
          notify(error.response.data.jurisdiction[0], { type: 'error' })
        } else {
          notify(JSON.stringify(error.response.data), { type: 'error' })
          console.error(error.response.data[0])
        }
        captureExceptionIfProduction(error)
      })
  }

  return <SaveButton {...props} onSave={handleClick} disabled={isLoading} />
}

const FuelCreateToolbar = (props: any) => (
  <Toolbar {...props}>
    <SaveButtonAltered label="Save" redirect="list" submitOnEnter={false} variant="text" />
  </Toolbar>
)

const FuelCreate = (props: any) => (
  <Create {...props}>
    <FuelForm fueltoolbar={<FuelCreateToolbar />} {...props} />
  </Create>
)

export default FuelCreate
